<template>
  <el-dialog
    :model-value="props.isOpen"
    @update:model-value="emit('update:isOpen', $event)"
    title="Информация о доставке"
    class="dialog"
    center
    @close="cargoInfoDeliveryForm.handleClose"
    @open="onOpenForm"
  >
    <el-form ref="cargoInfoDeliveryFormRef" :rules="cargoInfoDeliveryForm.rules" :model="cargoInfoDeliveryForm.model">
      <div class="addressWrapperCustom">
        <el-form-item label="Адрес доставки" prop="addressCargoDelivery" class="modalFormItem">
          <AddressAutocompleteSelectOnly
            :onCommandClick="() => cargoInfoDeliveryFormRef.validateField(['addressCargoDelivery', 'detailsDelivery'])"
            :modalState="props.isOpen"
            v-model:address="cargoInfoDeliveryForm.model.addressCargoDelivery"
            :city="dataForm.consignee.cityTo"
          />
        </el-form-item>
        <el-form-item style="flex: 1" label="Уточнение адреса" prop="detailsDelivery" class="modalFormItem">
          <el-input
            v-model="cargoInfoDeliveryForm.model.detailsDelivery"
            @blur="cargoInfoDeliveryForm.model.detailsDelivery = cargoInfoDeliveryForm.model.detailsDelivery.trim()"
            placeholder="Уточнение"
            @input="() => cargoInfoDeliveryFormRef.validateField(['addressCargoDelivery', 'detailsDelivery'])"
          />
        </el-form-item>
      </div>
      <el-form-item label="Время доставки" prop="cargoTimeDelivery">
        <el-select
          value-key="intervalTitle"
          style="width: 100%"
          v-model="cargoInfoDeliveryForm.model.cargoTimeDelivery"
          placeholder="Выберите желаемое время доставки"
          v-cancel-read-only
          autocomplete="do-not-autofill"
        >
          <el-option v-for="time in dataForm.fetchedDeliveryTimeIntervals" :key="time.intervalTitle" :label="time.intervalTitle" :value="time" />
        </el-select>
      </el-form-item>

      <el-form-item prop="whoPaysCargoDelivery" label="Плательщик ">
        <el-radio-group @change="handleChangePayerModalForm('cargoDelivery', $event)" class="radioGroupButtonsDefault" v-model="cargoInfoDeliveryForm.model.whoPaysCargoDelivery">
          <el-radio-button label="Отправитель" value="Отправитель" />
          <el-radio-button label="Получатель" value="Получатель" />
          <el-radio-button label="Третье лицо" :disabled="!dataForm.getThirdPersonAvailable" value="Третье лицо" />
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="typeOfPaymentCargoDelivery" label="Плательщик за забор груза">
        <el-radio-group class="radioGroupButtonsDefault" v-model="cargoInfoDeliveryForm.model.typeOfPaymentCargoDelivery">
          <el-radio-button label="Наличные" value="Наличные" />
          <el-radio-button :disabled="checkDisabledAccount(cargoInfoDeliveryForm.model.whoPaysCargoDelivery)" label="Расчётный счет юр. лица" value="Расчётный счет юр. лица" />
        </el-radio-group>
      </el-form-item>

      <div style="width: 100%; display: flex; justify-content: center">
        <el-button class="button_send" type="primary" @click="cargoInfoDeliveryForm.submitForm(cargoInfoDeliveryFormRef)"> Сохранить </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { inject, ref } from 'vue';

import { AddressAutocompleteSelectOnly } from '@/newCargoPickUpPage/Components';

const props = defineProps({
  isOpen: Boolean,
});

const checkDisabledAccount = inject('checkDisabledAccount');

const emit = defineEmits(['update:isOpen']);

const payersProps = inject('payersProps');

const handleChangePayerModalForm = (prop, value) => {
  for (let payerProp of Object.keys(payersProps)) {
    if (payerProp !== prop && payersProps[payerProp][0].value === value) {
      cargoInfoDeliveryForm.value.model.typeOfPaymentCargoDelivery = payersProps[payerProp][1].value;
      return;
    }
  }
  cargoInfoDeliveryForm.value.model.typeOfPaymentCargoDelivery = 'Наличные';
};

const dataForm = useNewDataFormCargoPickUpStore();

const handleChangeTypeOfPayment = inject('handleChangeTypeOfPayment');

const cargoInfoDeliveryFormRef = ref();
const cargoInfoDeliveryForm = ref({
  model: {
    addressCargoDelivery: dataForm.consignee.addressCargoDelivery,
    detailsDelivery: dataForm.consignee.detailsDelivery,
    cargoTimeDelivery: dataForm.consignee.cargoTimeDelivery,
    whoPaysCargoDelivery: dataForm.consignee.whoPaysCargoDelivery,
    typeOfPaymentCargoDelivery: dataForm.consignee.typeOfPaymentCargoDelivery,
  },
  rules: {
    addressCargoDelivery: [
      {
        validator: (rule, value, callback) => {
          if (!value && !cargoInfoDeliveryForm.value.model.detailsDelivery) {
            callback(new Error('Выберите адрес'));
          }
          callback();
        },
        trigger: 'change',
      },
    ],
    detailsDelivery: [
      {
        validator: (rule, value, callback) => {
          if (!value && !cargoInfoDeliveryForm.value.model.addressCargoDelivery) {
            callback(new Error('Введите уточнение'));
          }
          callback();
        },
        trigger: 'change',
      },
    ],
    cargoTimeDelivery: [{ required: true, message: 'Выберите время', trigger: 'change' }],
    whoPaysCargoDelivery: [{ required: true, message: 'Выберите опцию', trigger: 'change' }],
    typeOfPaymentCargoDelivery: [{ required: true, message: 'Выберите опцию', trigger: 'change' }],
  },
  handleClose: () => {
    if (!dataForm.consignee.addressCargoDelivery && !dataForm.consignee.detailsDelivery) {
      resetSenderForm();
    }
    emit('update:isOpen', false);
    cargoInfoDeliveryFormRef.value?.clearValidate();
  },
  submitForm: async (formEl) => {
    if (!formEl) return;
    await formEl.validate((valid) => {
      if (valid) {
        dataForm.consignee.addressCargoDelivery = cargoInfoDeliveryForm.value.model.addressCargoDelivery;
        dataForm.consignee.detailsDelivery = cargoInfoDeliveryForm.value.model.detailsDelivery;
        dataForm.consignee.cargoTimeDelivery = cargoInfoDeliveryForm.value.model.cargoTimeDelivery;
        dataForm.consignee.whoPaysCargoDelivery = cargoInfoDeliveryForm.value.model.whoPaysCargoDelivery;
        dataForm.consignee.typeOfPaymentCargoDelivery = cargoInfoDeliveryForm.value.model.typeOfPaymentCargoDelivery;

        handleChangeTypeOfPayment('cargoDelivery', cargoInfoDeliveryForm.value.model.typeOfPaymentCargoDelivery);

        emit('update:isOpen', false);
      }
    });
  },
});

const resetSenderForm = () => {
  cargoInfoDeliveryFormRef.value?.resetFields();
  dataForm.consignee.addressCargoDelivery = '';
  dataForm.consignee.detailsDelivery = '';
  dataForm.consignee.cargoTimeDelivery = '';
  dataForm.consignee.whoPaysCargoDelivery = '';
  dataForm.consignee.typeOfPaymentCargoDelivery = '';
};

const onOpenForm = () => {
  cargoInfoDeliveryForm.value.model.addressCargoDelivery = dataForm.consignee.addressCargoDelivery;
  cargoInfoDeliveryForm.value.model.detailsDelivery = dataForm.consignee.detailsDelivery;
  cargoInfoDeliveryForm.value.model.cargoTimeDelivery = dataForm.consignee.cargoTimeDelivery;
  cargoInfoDeliveryForm.value.model.whoPaysCargoDelivery = dataForm.consignee.whoPaysCargoDelivery;
  cargoInfoDeliveryForm.value.model.typeOfPaymentCargoDelivery = dataForm.consignee.typeOfPaymentCargoDelivery;
};
</script>

<style lang="scss">
.addressWrapperCustom {
  display: flex;
  flex-direction: column;
  width: 100%;
  .el-form-item {
    flex: 1;
  }
}
@media (max-width: 1280px) {
  .addressWrapperCustom {
    flex-direction: column;
  }
}
</style>
